import { initializeAnalytics } from '@firebase/analytics';

import { Analytics } from 'firebase/analytics';
import { FirebaseApp, FirebaseOptions, getApp, initializeApp } from 'firebase/app';

/**
 * Factory function to create the Firebase Analytics instance
 */
export function originAnalyticsServiceFactory(firebaseOptions: FirebaseOptions): Analytics {
    if (!firebaseOptions.projectId) {
        throw new Error('Firebase projectId must be provided');
    }
    let app: FirebaseApp;
    try {
        app = getApp();
    } catch {
        app = initializeApp(firebaseOptions, {
            automaticDataCollectionEnabled: false
        });
    }

    return initializeAnalytics(app, {
        config: {
            send_page_view: false
        }
    });
}
